module.exports = __webpack_public_path__ + "static/media/Portal da Nota Fiscal Eletrônica.e49e4747.pdf";